import React, { useState, useEffect } from "react";
import "./draftbanner.css";
import WeatherImage from "../images/bgimage.jpeg";
import footer from "../images/bgfooter.png";
import { valdiatePage } from "../global";
import { getActiveBanner } from "../services/portalbannerservice";
import { setLoading } from "../redux/appSlice";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { FaBullhorn } from "react-icons/fa";

const DraftModal = ({ reset }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  
  const d = {
    id: 0,
    Title: "",
    TitleDescription: "",
    BannerText: "",
    BgImageName: "",
    BgImageOpacity: 0,
    IsBgImage: false,
    status: false,
    FooterImageName: "",
    FooterImageOpacity: 0,
    IsFooterImage: false,
    FontId: 1,
    FontColor: "",
    BackgroundColor: "",
    BgColorOpacity: 0,
    BgImageSavedFile: "",
    FooterImageSavedFile: "",
    IsActive: true,
  };

  const [data, setData] = useState(d);

  window.onclick = function (event) {
    var modal = document.getElementById("myModal");
    if (event.target === modal) {
      reset();
    }
  };

  const onFirstClick = () => {
    reset();
  };

  useEffect(async () => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    if (valdiatePage("/")) {
      dispatch(setLoading({ data: true }));
      const rs = await getActiveBanner();
      dispatch(setLoading({ data: false }));

      if (rs.sts == 0) {
        const x = rs.data;
        setData((prev) => {
          return {
            ...prev,
            id: x.id,
            IsActive: x.IsActive,
            Title: x.Title,
            TitleDescription: x.TitleDescription,
            BannerText: x.BannerText,
            BgImageName: x.BgImageName,
            BgImageOpacity: x.BgImageOpacity.toFixed(1),
            IsBgImage: x.IsBgImage,
            status: x.status,
            FooterImageName: x.FooterImageName,
            FooterImageOpacity: x.FooterImageOpacity.toFixed(1),
            IsFooterImage: x.IsFooterImage,
            FontId: x.FontId,
            FontColor: x.FontColor,
            BackgroundColor: x.BackgroundColor,
            BgColorOpacity: x.BgColorOpacity.toFixed(1),
            BgImageSavedFile: rs.data.BgImageSavedFile,
            FooterImageSavedFile: rs.data.FooterImageSavedFile,
          };
        });
      } else {
        reset();
      }
    } else {
      history.push("/login");
    }

    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, []);


  return (

    data.Title ? <div id="myModal" className="draft-modal">
      <div className="announcement-modal">

        {/* HEADER */}
        <div className="announcement-header">
          <div className="announcement-title">
            <FaBullhorn className="announce-icon" />
            {data?.Title}
          </div>

          <button
            type="button"
            className="close-btn-banner"
            onClick={onFirstClick}
          >
            Close
          </button>
        </div>

        {/* IMAGE ONLY */}
        <div className="announcement-body">
          <img
            src={`data:image/png;base64,${data.BgImageSavedFile}`}
            alt="Announcement Banner"
            className="announcement-image"
          />
        </div>
      </div>
    </div> : <></> 
  );
};

export default DraftModal;










{/* <div id="myModal" className="draft-modal">
  <div className="draft-modal-content improved-modal" style={{ maxHeight: data.IsFooterImage ? "90%" : "98%" }}>
    
    <div className="draft-modal-header improved-header">
      <div></div>

      <div className="section announcement">
        <FaBullhorn className="announce-icon" />
        {data?.Title}
      </div>

      <button
        type="button"
        className="btn btn-sm btn-primary close-btn"
        onClick={() => onFirstClick()}
      >
        Close
      </button>
    </div>

    <div
      className="draft-modal-body improved-body"
      style={{
        height: data.IsFooterImage ? "68vh" : "86vh",
        backgroundImage: data.IsBgImage
          ? `linear-gradient(rgba(255,255,255,${data.BgImageOpacity}), rgba(255,255,255,${data.BgImageOpacity})), url("data:image/png;base64,${data.BgImageSavedFile}")`
          : "",
      }}
    >
      <div className="banner-wrapper">
        {data.TitleDescription && (
          <div className="banner-box" style={{ background: data.BackgroundColor, opacity: data.BgColorOpacity, color: data.FontColor }}>
            {data.TitleDescription}
          </div>
        )}

        {data.BannerText && (
          <div className="banner-box" style={{ background: data.BackgroundColor, opacity: data.BgColorOpacity, color: data.FontColor }}>
            {data.BannerText}
          </div>
        )}
      </div>
    </div>

    {data.IsFooterImage && (
      <img className="banner-footer" src={`data:image/png;base64,${data.FooterImageSavedFile}`} alt="logo" />
    )}
  </div>
</div> */}
